import { useNavigate } from 'react-router-dom';
import { 
  ArrowLeft, 
  FolderKanban, 
  HardHat, 
  FolderOpen, 
  Search, 
  Calendar, 
  Save, 
  Lock, 
  Eraser, 
  CheckCircle, 
  MapPin, 
  TrendingUp,
  FileCheck,
} from 'lucide-react';

export default function DocAdmin() {
  const navigate = useNavigate();

  return (
    <div style={{ fontFamily: 'Inter, sans-serif', maxWidth: '1000px', margin: '0 auto', padding: '40px 20px', color: '#1e293b' }}>
      
      {/* HEADER */}
      <div style={{ marginBottom: '40px', borderBottom: '1px solid #e2e8f0', paddingBottom: '20px' }}>
        {/* CORRECTION ICI : navigate('/') au lieu de navigate('/admin') */}
        <button onClick={() => navigate('/')} style={{ display:'flex', alignItems:'center', gap:'8px', border:'none', background:'transparent', color:'#64748b', cursor:'pointer', marginBottom:'15px', fontWeight:'600' }}>
          <ArrowLeft size={20} /> Retour Dashboard
        </button>
        <h1 style={{ fontSize: '2rem', margin: 0, color: '#1e293b' }}>Documentation Utilisateur <span style={{color:'#2563eb'}}>Direction</span></h1>
        <p style={{ color: '#64748b', marginTop: '10px', fontSize: '1.1rem' }}>
          Guide des fonctionnalités de pilotage, planification et validation.
        </p>
      </div>

      {/* SECTION 1 : PROJETS */}
      <div style={{ background: 'white', padding: '30px', borderRadius: '16px', border: '1px solid #e2e8f0', marginBottom: '30px', boxShadow: '0 4px 6px -1px rgba(0,0,0,0.05)' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '20px', color: '#2563eb' }}>
          <div style={{ background: '#eff6ff', padding: '10px', borderRadius: '10px' }}><FolderKanban size={28} /></div>
          <h2 style={{ margin: 0, fontSize: '1.5rem' }}>1. Gestion des Affaires</h2>
        </div>
        
        <p style={{ lineHeight: '1.6', color: '#475569' }}>
          La création des chantiers est la première étape obligatoire. Elle conditionne la saisie des heures et l'analyse de rentabilité.
        </p>

        <div style={{ marginTop: '20px', display: 'grid', gap: '20px' }}>
          <div style={{ background: '#f8fafc', padding: '20px', borderRadius: '12px', border: '1px solid #e2e8f0' }}>
            <h3 style={{ margin: '0 0 10px 0', fontSize: '1.1rem' }}>Catégorisation des Projets</h3>
            <p style={{ fontSize: '0.95rem', color: '#64748b', marginBottom: '15px' }}>
              Lors de la création, vous devez définir la nature comptable du projet via les boutons dédiés :
            </p>
            <ul style={{ listStyle: 'none', padding: 0, display: 'grid', gap: '10px' }}>
              <li style={{ display: 'flex', alignItems: 'center', gap: '10px', background: 'white', padding: '10px', borderRadius: '8px', border: '1px solid #e2e8f0' }}>
                <HardHat size={20} color="#059669" /> 
                <strong>Production :</strong> Pour les chantiers clients facturables. Impacte le chiffre d'affaires.
              </li>
              <li style={{ display: 'flex', alignItems: 'center', gap: '10px', background: 'white', padding: '10px', borderRadius: '8px', border: '1px solid #e2e8f0' }}>
                <FolderOpen size={20} color="#4338ca" /> 
                <strong>Divers / Interne :</strong> Pour les formations, SAV non facturables ou travaux internes.
              </li>
            </ul>
          </div>

          <div style={{ background: '#f8fafc', padding: '20px', borderRadius: '12px', border: '1px solid #e2e8f0' }}>
            <h3 style={{ margin: '0 0 10px 0', fontSize: '1.1rem' }}>Localisation Automatique</h3>
            <p style={{ fontSize: '0.95rem', color: '#64748b', marginBottom: '15px' }}>
              Le calcul de la zone de déplacement (1 à 7) est automatisé pour éviter les erreurs de saisie :
            </p>
            <ol style={{ paddingLeft: '20px', color: '#334155', lineHeight: '1.8' }}>
              <li>Saisissez l'adresse précise du chantier.</li>
              <li>Cliquez sur le bouton <strong style={{color:'#2563eb', display:'inline-flex', alignItems:'center', gap:'4px', verticalAlign:'middle'}}><Search size={14}/> Rechercher</strong>.</li>
              <li>Le système calcule la distance depuis le siège et attribue la <strong>Zone</strong> correspondante.</li>
            </ol>
          </div>
        </div>
      </div>

      {/* SECTION 2 : PLANIFICATION */}
      <div style={{ background: 'white', padding: '30px', borderRadius: '16px', border: '1px solid #e2e8f0', marginBottom: '30px', boxShadow: '0 4px 6px -1px rgba(0,0,0,0.05)' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '20px', color: '#2563eb' }}>
          <div style={{ background: '#eff6ff', padding: '10px', borderRadius: '10px' }}><Calendar size={28} /></div>
          <h2 style={{ margin: 0, fontSize: '1.5rem' }}>2. Planification des Équipes</h2>
        </div>

        <p style={{ lineHeight: '1.6', color: '#475569', marginBottom:'20px' }}>
          Le module Scheduler permet d'affecter les techniciens sur les chantiers. Le processus se déroule en deux temps pour plus de sécurité.
        </p>

        <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fit, minmax(300px, 1fr))', gap:'20px' }}>
          {/* Outils */}
          <div style={{ border:'1px solid #e2e8f0', borderRadius:'12px', padding:'20px' }}>
            <h4 style={{marginTop:0, display:'flex', alignItems:'center', gap:'8px'}}><Eraser size={18} /> Outils d'édition</h4>
            <p style={{fontSize:'0.9rem', color:'#64748b'}}>Sélectionnez un chantier en haut, puis cliquez sur les cases (Matin/Après-midi) pour l'affecter. Utilisez la <strong>Gomme</strong> pour retirer une affectation.</p>
          </div>

          {/* Sauvegarde */}
          <div style={{ border:'1px solid #e2e8f0', borderRadius:'12px', padding:'20px', background:'#f0f9ff' }}>
            <h4 style={{marginTop:0, display:'flex', alignItems:'center', gap:'8px', color:'#0369a1'}}><Save size={18} /> Étape 1 : Sauvegarder</h4>
            <p style={{fontSize:'0.9rem', color:'#334155'}}>
              Enregistre le planning en <strong>BROUILLON</strong>. Il est sauvegardé en base de données mais reste <strong>invisible</strong> pour les employés. Idéal pour préparer la semaine suivante.
            </p>
          </div>

          {/* Publication */}
          <div style={{ border:'1px solid #e2e8f0', borderRadius:'12px', padding:'20px', background:'#f0fdf4' }}>
            <h4 style={{marginTop:0, display:'flex', alignItems:'center', gap:'8px', color:'#15803d'}}><Lock size={18} /> Étape 2 : Publier</h4>
            <p style={{fontSize:'0.9rem', color:'#334155'}}>
              Verrouille la semaine et rend le planning <strong>VISIBLE</strong> sur les smartphones des techniciens. Une fois publié, le planning ne peut plus être modifié sans être repassé en brouillon.
            </p>
          </div>
        </div>
      </div>

      {/* SECTION 3 : VALIDATION */}
      <div style={{ background: 'white', padding: '30px', borderRadius: '16px', border: '1px solid #e2e8f0', boxShadow: '0 4px 6px -1px rgba(0,0,0,0.05)' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '20px', color: '#2563eb' }}>
          <div style={{ background: '#eff6ff', padding: '10px', borderRadius: '10px' }}><FileCheck size={28} /></div>
          <h2 style={{ margin: 0, fontSize: '1.5rem' }}>3. Contrôle & Validation</h2>
        </div>

        <ul style={{ lineHeight: '1.8', color: '#475569' }}>
          <li style={{marginBottom:'10px'}}>
            <strong>Sécurité Congés :</strong> Le système bloque automatiquement toute saisie d'heures par un employé sur une journée où un congé a été validé.
          </li>
          <li style={{marginBottom:'10px'}}>
            <strong>Validation :</strong> Allez dans le menu <span style={{background:'#f1f5f9', padding:'2px 6px', borderRadius:'4px', fontWeight:'600', fontSize:'0.85rem'}}>Validation</span>. Cliquez sur <span style={{color:'#10b981', fontWeight:'700'}}><CheckCircle size={14} style={{verticalAlign:'middle'}}/> Valider</span> pour approuver une feuille d'heures pour la paie.
          </li>
          <li>
            <strong>Tableau de Bord :</strong> Utilisez la carte <span style={{fontWeight:'600'}}><MapPin size={14} style={{verticalAlign:'middle'}}/> Localisation</span> pour voir les équipes en temps réel et la carte <span style={{fontWeight:'600'}}><TrendingUp size={14} style={{verticalAlign:'middle'}}/> Rentabilité</span> pour suivre la consommation budgétaire.
          </li>
        </ul>
      </div>

    </div>
  );
}